import './ServiceWorkerWrapper.scss';

import { CloseCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ServiceWorkerWrapper = () => {
  const { t } = useTranslation();
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      void navigator.serviceWorker.ready.then(() => {
        navigator.serviceWorker.addEventListener('message', event => {
          if (event.data?.type === 'NEW_VERSION_AVAILABLE') {
            setShowUpdate(true);
          }
        });
      });
    }

    return () => {
      if ('serviceWorker' in navigator) {
        void navigator.serviceWorker.ready.then(registration => {
          registration.active?.removeEventListener('message', () => {
            /* empty */
          });
        });
      }
    };
  }, []);

  if (!showUpdate) return null;

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="ServiceWorkerWrapper">
      <p>{t('Una nueva versión de la web está disponible')}</p>
      <div className="ServiceWorkerWrapperLink" role="button" tabIndex={0} onClick={reloadPage}>
        {t('Actualizar')}
      </div>
      <CloseCircleOutlined className="IconClose" onClick={() => setShowUpdate(false)} />
    </div>
  );
};

export default ServiceWorkerWrapper;
